import {Component, Input, OnInit} from '@angular/core';
import {DashboardService} from "@services/dashboard.service";
import {NgxSpinnerService} from "ngx-spinner";
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RequestService} from '@services/request.service';

@Component({
  selector: 'app-autoload-offerte',
  templateUrl: './autoload-offerte.component.html',
  styleUrls: ['./autoload-offerte.component.css']
})
export class AutoloadOfferteComponent implements OnInit {
    @Input() brand: string;
    _urlOfferte: string;
    autoloadTableUrl: string;
    data: any;
    status = 'hidden';

    @Input() set urlOfferte(value: string) {
        this._urlOfferte = value;

        if (this._urlOfferte !== undefined) {
            this.loadOfferte();
        }
    }

    constructor(
        private requestService: RequestService,
        private modalService: NgbModal
    ) {
    }

    ngOnInit() {
    }

    loadOfferte() {
        this.status = 'loading';
        this.requestService.get(this.brand + this._urlOfferte)
            .subscribe((data) => {
                this.data = data.result;
                this.status = 'hidden';
            }, (error) => {
                this.status = 'error';
            });
    }

    openAutoloadTable(modal, col) {
        if (col.hasOwnProperty('url')) {
            this.autoloadTableUrl = `${col.url}`;

            this.modalService.open(modal, {size: 'xl'});
        }
    }
}
